<template>
  <div class="toolbar">
    <span v-if="!isEnglish" class="text-red text-link font-12 font-weight" @click="jumpLogin">{{$root.language.login}}</span> |
    <span class="text-red text-link font-12 font-weight" @click="jumpContact">{{$root.language.contactUs}}</span>
    <img @click="handleLanguage('en-US')" class="text-link" width="35" src="@/assets/img/english.jpg" alt="">
    <img @click="handleLanguage('zh-CN')" class="text-link" width="35" src="@/assets/img/china.jpg" alt="">
  </div>
</template>

<script>
export default {
  props: {
    isEnglish: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    jumpLogin () {
      window.open('http://cloud.jwis.cn/#/login')
    },

    jumpHome () {
      this.$router.push({
        path: '/'
      })
    },

    jumpContact () {
      this.$router.push({
        path: '/company/contact'
      })
    },

    handleLanguage (value) {
      if (value !== localStorage.getItem('jw-locale')) {
        localStorage.setItem('jw-locale', value)
        // this.jumpHome()
        this.handleReload()
      }
    },

    handleReload () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.toolbar { margin-top: 5px;}
.toolbar .text-link {padding: 0 5px;}
</style>
